import { Stack } from "expo-router/stack";
import { theme } from "@theme";

export default function Layout() {
  return (
    <>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.screenBg,
          },
        }}
      >
        <Stack.Screen name="index" />
        <Stack.Screen name="quiz-2" />
        <Stack.Screen name="analysing" />
        <Stack.Screen name="aha-1" />
        <Stack.Screen name="aha-2" />
        <Stack.Screen name="aha-3" />
        <Stack.Screen name="aha-4" />
        <Stack.Screen name="link-streaming-service" />
        <Stack.Screen name="pick-genres" />
        <Stack.Screen name="callback" />
        <Stack.Screen name="notification" />
        <Stack.Screen name="loading" />
      </Stack>
    </>
  );
}
